import React from 'react'
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Typography,
} from '@mui/material'
import { LocationOn } from '@mui/icons-material'
import { useAppSelector } from '@hooks/redux'

interface ApiarySelectorProps {
    selectedApiaryId: number | null
    onApiaryChange: (apiaryId: number | null) => void
    disabled?: boolean
    label?: string
}

const ApiarySelector: React.FC<ApiarySelectorProps> = ({
    selectedApiaryId,
    onApiaryChange,
    disabled = false,
    label = 'Select apiary',
}) => {
    const { apiaries } = useAppSelector((state) => state.locations)

    const handleChange = (event: any) => {
        const value = event.target.value
        onApiaryChange(value === '' ? null : value)
    }

    return (
        <FormControl fullWidth disabled={disabled} size="small">
            <InputLabel>{label}</InputLabel>
            <Select
                value={selectedApiaryId || ''}
                onChange={handleChange}
                label={label}
                startAdornment={
                    <LocationOn sx={{ mr: 1, color: 'text.secondary', fontSize: '1.1rem' }} />
                }
            >
                <MenuItem value="">
                    <em>All apiaries</em>
                </MenuItem>
                {apiaries.map((apiary) => (
                    <MenuItem key={apiary.id} value={apiary.id}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="body2">{apiary.name}</Typography>
                            {apiary.address && (
                                <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                                    ({apiary.address})
                                </Typography>
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default ApiarySelector
